import ContactList from "../components/ContactList";

function Contact() {
  return <ContactList />;
}

export default Contact;
